module.exports = __webpack_public_path__ + "2f65ea24bf36cd04e5f837db20bb0686.png";